import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { createSecretColumns } from "./table/columns";

type SecretsViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type SecretsViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useSecretsViewOptions = ({
  onVisibilityChange,
}: SecretsViewOptionsProps = {}): SecretsViewOptionsReturn => {
  // Get column definitions
  const columns = useMemo(() => createSecretColumns({}), []);

  // Use the generic table view options hook
  return useTableViewOptions({
    columns,
    storageKey: "secrets-table-column-visibility",
    onVisibilityChange,
    label: "Columns",
    className: "h-9 px-3 gap-2",
  });
};
